import "admin/src/style/videoMetadataPage.css";
import client from "libs/client";
import { useLocation, useNavigate } from "react-router";
import { useToast } from "ui-kit";
import { getVideoUploadErrorMessage } from "./videoUploadErrors";

interface DeleteModalProps {
	videoId: number;
	close: () => void;
	/** Where to go once the upload is gone. Omit to stay put, e.g. when deleting a row from a table. */
	navigateAfterDelete?: string;
	onDeleted?: () => void;
}

export function DeleteModal({ videoId, close, navigateAfterDelete, onDeleted }: DeleteModalProps) {
	const { addSuccessToast, addErrorToast } = useToast();
	const navigate = useNavigate();
	const location = useLocation();

	const deleteMutation = client.deleteVideoUpload.useMutation({
		onSuccess: () => {
			addSuccessToast(`Video ${videoId} has been successfully deleted.`);
			client.queryClient.invalidateQueries({
				predicate: (query) => query.queryKey.includes("metadataVideos") || query.queryKey.includes("gameData"),
			});
			close();
			onDeleted?.();
			if (navigateAfterDelete !== undefined && location.pathname !== navigateAfterDelete) {
				navigate(navigateAfterDelete);
			}
		},
		onError: (res) => {
			addErrorToast(getVideoUploadErrorMessage(res, `Video ${videoId} could not be deleted`));
		},
	});

	const onSubmit = () => {
		deleteMutation.mutate({ id: videoId });
	};

	return (
		<div className="approveVideoModal-container">
			<div className="approveMessage">
				The whole upload will be deleted and file will have to be uploaded again. Are you sure you want to delete the upload?
			</div>
			<div className="buttons">
				<div className="submit" onClick={() => onSubmit()}>
					Delete
				</div>
				<div className="cancel" onClick={() => close()}>
					Cancel
				</div>
			</div>
		</div>
	);
}
